export function currency (value) {
  return value.toFixed(2)
}

export default {
  currency,
}



// WEBPACK FOOTER //
// ./src/filters.js